<template>
    <div>
      <!--    搜索部分-->
      <el-form :inline="true" :model="enquiryForm" class="demo-form-inline " label-width="80px">
        <div class="formOne">
          <el-form-item label="手机号">
            <el-input size="medium" clearable v-model="enquiryForm.phone" placeholder="手机号"></el-input>
          </el-form-item>
          <el-form-item label="状态" >
            <el-select v-model="enquiryForm.status" medium clearable placeholder="请选择状态">
              <el-option v-for="(item,index) in statusText" :key="index" :label="item"  :value="index"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div style="margin-bottom: 10px">
        <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询</el-button>
        <el-button size="medium" style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
        <el-button size="medium" style="font-size: 12px;" @click="handleEditFrom(0);">添加</el-button>
        <el-button size="medium" type="warning" style="font-size: 12px;" @click="exportData()">导出</el-button>

      </div>
      <!--    表格部分-->
      <el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'id', order: 'descending'}"
                v-loading="loading" border id="tableDataId" size="mini">
        <el-table-column header-align="center" align="center" prop="id" label="ID" sortable>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="user_name" label="用户名">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="mobile_phone" label="用户手机号">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="real_name" label="姓名">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="auth_status" label="实名认证">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.auth_status == '10'"  disable-transitions>
                未认证
              </el-tag>
            <el-tag v-if="scope.row.auth_status == '20'"  disable-transitions>
                认证中
            </el-tag>
            <el-tag v-if="scope.row.auth_status == '30'" type="success" disable-transitions>   
               认证成功 
             </el-tag>
            <el-tag v-if="scope.row.auth_status == '40'" type="warning" disable-transitions>
               认证失败
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="status" label="状态">
          <template slot-scope="scope">
              {{ scope.row.status.text }}
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="operator" label="操作人">
      
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="update_time" label="操作时间">
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="medium" type="danger" style="font-size: 12px;" @click="handleEditFrom(scope.row.id,scope.row.mobile_phone,scope.row.status.value);" >
                编辑
            </el-button>
          </template>
        </el-table-column>  
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :page-sizes="[20,50,100,200,500,1000]" :page-size="enquiryForm.limit" :total="total"
      layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>
      <!-- 表格结束 -->
       <!--表单-->
      <fromIdent 
      v-if="fromVisible"
       :fromVisible="fromVisible" 
       :ident_id="ident_id"
       :status="identData.status"
       :phone="identData.phone"
       @handleFromVisible="handleFromVisible"
       />
      <!--表单结束-->
    </div>
  </template>
  <script>
  import fromIdent from "./components/fromIdent"
  import {export_json_to_excel} from "@/excel/Export2Excel";
  export default {
    name: "rolelist",
    components:{
      fromIdent
    },
    data() {
      return {
        // 主页面部分
        loading: true, //列表loadding
        total: 0, //总数
        tableData: [], //表格数据
        enquiryForm: { //检索条件
          user_account: "", //用户账号
          limit: 20,
          page: 1,
        },
        fromVisible:false, //是否显示表单 
        ident_id:0,
        statusText:{
           0:"停用",
           1:"启用",
        },
        authstatusText:{
          '10':'未认证',
          '20':'认证中',
          '30':'认证成功',
          '40':'认证失败',
        },
        identData:{ //单调数据
          status:null,
          phone:null,
        }

      }
    },
    created() {
      this.getData(this.enquiryForm);
    },
    methods: {
      // 主页面部分
      //搜索
      handleSearch(searchForm) {
        searchForm.page = 1;
        this.getData(searchForm);
      },
      //重置
      Reset(searchForm) {
          searchForm.role_name = "", //角色名称
          searchForm.limit = 20,
          searchForm.page = 1,
        this.getData(searchForm);
      },
      //分页
      handleCurrentChange(page) { //当前选中页
        this.enquiryForm.page = page;
        this.getData(this.enquiryForm);
      },
      handleSizeChange(limit) { //条数
        this.enquiryForm.limit = limit;
        this.enquiryForm.page = 1;
        this.getData(this.enquiryForm);
      },
      //获取数据
      getData(params) { //初始化数据
        this.loading = true;
        this.$api.post("/api/dividend_vip/getList?page=" + params.page, params, res => {
          if (res.status == 200) {
            let tableData = res.data;
            this.total = tableData.total; //总数
            this.tableData = tableData.list;
          } else {
            this.$message.error(res.msg);
          }
          //渲染结束后取消加载
          this.loading = false;
        })
      },
      //关闭/打开表单  
      handleFromVisible(fromVisible){
        if(fromVisible == false){
          this.getData(this.enquiryForm);
        }
        this.fromVisible = fromVisible;
      },
  
      //编辑打开表单 
      handleEditFrom(ident_id,phone=null,status=null){
        this.ident_id = ident_id;
        this.identData.phone = phone;
        this.identData.status = status;
        this.handleFromVisible(true);
      },
       // 导出
      exportData() {
        let th = ['ID', '用户名', '用户手机号', '姓名', '实名认证', '状态', '操作人','操作时间'];
        let excelData = ['id', 'user_name', 'mobile_phone', 'real_name', 'auth_status_text', 'status_text', 'operator','update_time'];
        this.tableData.forEach(item => { //分润类型转换文本
          item.auth_status_text = this.authstatusText[item.auth_status] ?  this.authstatusText[item.auth_status] : '';
          item.status_text = item.status.text;
        });
        let data = this.formatJson(excelData, this.tableData);
        let defaultTitle = '导出文件';
        export_json_to_excel(th, data, defaultTitle)
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },
    }
  }
  </script>
  <style scoped>
  /deep/ .el-form-item__content .el-input-group {
    vertical-align: middle !important;
  }
  .code {
    cursor: pointer;
  }
  .code:hover {
    color: #5111ee;
    text-decoration: underline;
  }
  /*::v-deep .is-leaf{*/
  /*  color: #000000;*/
  /*  font-weight: bold;*/
  /*  background-color: #e5e4e4;*/
  /*}*/
  
  </style>
  